import React from 'react';
import { Form, Upload, Button, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd';
import localStorageUtil from '@/utils/localStorageUtil';

/**
 * 图片上传字段组件属性
 */
interface ImageUploadFieldProps {
  name: string;
  label: string;
  maxCount?: number;
  fileList: UploadFile[];
  isViewMode: boolean;
  onChange: (info: any, name: string) => void;
}

/**
 * 图片上传字段组件
 * 用于展示和上传图片
 */
const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  name,
  label,
  maxCount,
  fileList,
  isViewMode,
  onChange,
}) => {
  // 查看模式
  if (isViewMode) {
    const count = fileList?.length || 0;
    // 只有设置了 maxCount 才显示数量限制
    const countText = maxCount ? ` (${count}/${maxCount})` : '';

    return (
      <Form.Item label={`${label}${countText}`}>
        {fileList && fileList.length > 0 ? (
          <Image.PreviewGroup>
            {fileList.map((file: any) => (
              <Image key={file.uid} width={100} src={file.url} style={{ marginRight: 8 }} />
            ))}
          </Image.PreviewGroup>
        ) : (
          '暂无图片'
        )}
      </Form.Item>
    );
  }

  // 编辑模式
  return (
    <Form.Item label={label}>
      <Upload
        action="/api/v2/resource/upload"
        listType="picture"
        fileList={fileList}
        onChange={(info) => onChange(info, name)}
        headers={{ access_token: localStorageUtil.getItem('access_token') }}
        maxCount={maxCount}
      >
        <Button icon={<UploadOutlined />}>上传图片</Button>
      </Upload>
    </Form.Item>
  );
};

export default ImageUploadField;
